export default {"src":"/_next/static/media/ic-tick.34d9c7e3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};